import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export const initialState = {
  vodRails: [],
};

export default {
  state: {
    ...initialState,
  },
  actions,
  mutations,
  getters,
};
